import { render, staticRenderFns } from "./wechatShare.vue?vue&type=template&id=5148ce98&scoped=true&"
import script from "./wechatShare.vue?vue&type=script&lang=js&"
export * from "./wechatShare.vue?vue&type=script&lang=js&"
import style0 from "./wechatShare.vue?vue&type=style&index=0&lang=css&"
import style1 from "./wechatShare.vue?vue&type=style&index=1&id=5148ce98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5148ce98",
  null
  
)

export default component.exports